import { Alpine } from "./main.alpinejs.js";
import "./main.data.js";

Alpine.start();
document.getElementsByTagName("html")[0].classList.add("has-js");